const ITag = ({...props}) => <i {...props} />

export default ITag